import { createFileRoute } from "@tanstack/react-router";
import { ArticlesView } from "../../app/views/admin/articles";

export const Route = createFileRoute("/admin/articles")({
  component: ArticlesView,
});
